import type { GuestTabletSessionDisplay } from "@/types/guestTablet";

function sitePlanPitchKey(plan: GuestTabletSessionDisplay["site_plan"]): string {
  if (!plan?.pitches?.length) return "";
  return plan.pitches
    .map((p) => `${p.pitch_id}:${p.highlight}`)
    .sort()
    .join("|");
}

/**
 * Behält das Stellplatzplan-Bild bei, wenn die API es erneut mitschickt oder
 * bei schwacher Verbindung nur Metadaten/Polygone aktualisiert.
 */
export function mergeGuestTabletSession(
  previous: GuestTabletSessionDisplay | null,
  incoming: GuestTabletSessionDisplay,
): GuestTabletSessionDisplay {
  if (!previous?.site_plan?.image_data || !incoming.site_plan) {
    return incoming;
  }

  const prevKey = sitePlanPitchKey(previous.site_plan);
  const nextKey = sitePlanPitchKey(incoming.site_plan);
  const nextImage = incoming.site_plan.image_data?.trim();
  if (nextImage || prevKey !== nextKey) {
    return incoming;
  }

  return {
    ...incoming,
    site_plan: {
      ...incoming.site_plan,
      image_data: previous.site_plan.image_data,
      badge_scale: incoming.site_plan.badge_scale || previous.site_plan.badge_scale,
    },
  };
}
